import React, { useEffect } from "react";
import Home from "../Home/Home";
import footer from "../Home/Footer/Footer";
import NavbarService from "./NavbarService";



function AstrologyPage() {
  const whatsappNumber = "919332283222"; 
  const whatsappMessage =
    "Hello, I want to know more about Astrology & Horoscope services.";

  return (
    <>
        <NavbarService/>
           <div className="container mb-5" style={{marginTop: '8rem'}}>
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="card shadow-lg border-0 p-4">
            <div className="card-body">
              {/* Title */}
              <h2 className="text-center mb-3">Astrology & Horoscope</h2>
              <p className="text-center text-muted">
                Unlock the secrets of your future with our expert Astrology and
                Horoscope services.
              </p>

              {/* Details */}
              <h4 className="mt-4">What We Offer</h4>
              <ul>
                <li>Personalized Horoscope Predictions</li>
                <li>Detailed Kundli Analysis</li>
                <li>Career, Health & Relationship Guidance</li>
                <li>Remedies & Gemstone Suggestions</li>
              </ul>

              {/* Price */}
              <div className="mt-4 p-3 bg-light rounded shadow-sm">
                <h5 className="mb-1">
                  <span className="text-muted text-decoration-line-through">₹1100</span>{" "}
                  <span className="text-success fw-bold">₹500 / session</span>
                </h5>
                <small className="text-danger fw-semibold">
                  ({Math.round(((1100 - 500) / 1100) * 100)}% OFF)
                </small>
                <p className="text-muted mt-2 mb-0">
                  Includes one detailed Kundli + 30 min consultation
                </p>
              </div>

              {/* Buttons */}
              <div className="mt-4 d-flex gap-3">
                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                    whatsappMessage
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success"
                >
                  
                  WhatsApp Us
                </a>

                <button
                  className="btn btn-outline-primary"
                  onClick={() => alert("Coming soon!.")}
                >
                  Ask for Details
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer/>
    </>
 
  );
}

export default AstrologyPage;
